import React, { useState } from 'react';

import { FormControlLabel, Checkbox } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

import { QUESTION_FORM_SOURCES } from 'constants/ProjectConstants';

import { CheckboxesContainer, Separator } from './styles';

const CommentsCheckboxes = ({ question, handleQuestionChange, source, isDuplicating }) => {
  const [data, setData] = useState(true);
  const checkboxLabel = `Allow ${source === 'review' ? 'reviewers' : 'employees'} to add comment`;

  const onDataChange = () => {
    setData((prevData) => !prevData);
    handleQuestionChange('isTextRequired', !data);
  };

  const isDisabled =
    !isDuplicating &&
    (source === QUESTION_FORM_SOURCES.ENGAGEMENT || source === QUESTION_FORM_SOURCES.REVIEW) &&
    question?.isEditable === false;

  return (
    <CheckboxesContainer>
      <FormControlLabel
        control={
          <Checkbox
            checked={question.enableFeedbackText}
            onChange={(e) => handleQuestionChange('enableFeedbackText', e.target.checked)}
            name="checkedB"
            color="primary"
            icon={<RadioButtonUncheckedIcon fontSize="small" />}
            checkedIcon={<CheckCircleIcon fontSize="small" />}
          />
        }
        label={checkboxLabel}
        disabled={isDisabled || (source === 'engagement' && question?.isEditable === false && !isDuplicating)}
      />

      {question.enableFeedbackText && (
        <>
          <Separator />
          <FormControlLabel
            class="marginLeft"
            control={
              <Checkbox
                checked={!question.isTextRequired}
                onChange={onDataChange}
                name="checkedB"
                color="primary"
                icon={<RadioButtonUncheckedIcon fontSize="small" />}
                checkedIcon={<CheckCircleIcon fontSize="small" />}
              />
            }
            label="Make comment optional"
            disabled={isDisabled || (source === 'engagement' && question?.isEditable === false && !isDuplicating)}
          />
        </>
      )}
    </CheckboxesContainer>
  );
};

export default CommentsCheckboxes;
